import { isIwocaDE } from 'utils/countryHelper';

const isProd = import.meta.env.PROD;
const country = isIwocaDE() ? 'de' : 'en-GB';

export const ASSET_PREFIX =
  country === 'de' && isProd
    ? import.meta.env.VITE_PUBLIC_URL_DE
    : country !== 'de' && isProd
      ? import.meta.env.VITE_PUBLIC_URL
      : '';
